import { injectGlobal } from '@emotion/css';

// These colour variables are set up in sections to reflect the style guide and make it easier to follow and maintain.

// Business Theme Colours
injectGlobal(`
  :root {
    --color-white: #FFFFFF;



    --color-red-hot: #E10A0A;

    --color-primary: var(--color-red-hot);
    --color-danger: var(--color-red-hot);
    --color-hover: var(--color-red-hot);
    --color-selected: var(--color-red-hot);

    --color-midnight-blue: #051441;

    --color-dark: var(--color-midnight-blue);
    --color-deep-blue: var(--color-midnight-blue);



    --color-lime: #D3E629;

    --color-secondary: var(--color-lime);



    --color-midnight-blue-light: #323A57;

    --color-secondary-2: var(--color-midnight-blue-light);



    --color-red-light: #E73B3B;

    --color-primary-light: var(--color-red-light);



    --color-red-dark: #C20000;

    --color-primary-dark: var(--color-red-dark);
    --color-active: var(--color-red-dark);



    --color-charcoal: #1E2332;

    --color-dark-2: var(--color-charcoal);

    --color-dark-tint: #33396C;
    --color-deep-blue-light: var(--color-dark-tint);

    --color-deep-blue-dark: #02041E;
  }
`);

// Grayscale Palette Colours
injectGlobal(`
  :root {
    --color-black: #000000;
    --color-grey: #6D7173;
    --color-mid-grey: #DFE3E6;
    --color-light-grey: #FAFAFA;

    --color-body: var(--color-black);
    --color-link: var(--color-black);
    --color-muted: var(--color-grey);
    --color-border: var(--color-mid-grey);
    --color-info: var(--color-mid-grey);
    --color-light: var(--color-light-grey);
  }
`);

// Colours defined solely in the buttons section.
// --color-dark-2-light is only used as the tertiary button active background-color
injectGlobal(`
  :root {
    --color-dark-2-light: #4B5056;
  }
`);

// Colours not defined in the style guide but used in the designs
// --color-red-lightest is --color-red-light with 50% opacity applied
injectGlobal(`
  :root {
    --color-error-container: #F3B1A0;
    --color-lime-darker: #9EB400;
  }
`);
